import {
	MODULE_GLOBAL_NAME,
	SET_MANUFACTURERS,
	MANUFACTURERS
} from '@/sections/transactions/shared/global-mutation-types.js';

import { ApiGlobalService as api } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';

const baseApi = `/${MODULE_GLOBAL_NAME}`;

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: MODULE_GLOBAL_NAME,
	namespaced: true,
	state: {
		[MANUFACTURERS]: {}
	},
	mutations: {
		[SET_MANUFACTURERS](state, data) {
			state[MANUFACTURERS] = data;
		}
	},
	actions: {
		async [SET_MANUFACTURERS]({ commit }) {
			commit(SET_MANUFACTURERS, {});
			const results = await api.get(
				buildRoute(baseApi + '/manufacturers')
			);
			commit(SET_MANUFACTURERS, results);
			return results;
		}
	},
	getters: {
		[MANUFACTURERS]: state => state[MANUFACTURERS]
	}
};
